import React from 'react';
import { NavLink } from 'react-router-dom';

/* Barre de navigation commune aux pages « sous-traitance photovoltaïque » (donneurs d'ordre) :
   un seul espace clair au lieu de pages séparées qui se recoupent. */
const LIENS = [
  ['/sous-traitance-photovoltaique', 'Présentation'],
  ['/grands-comptes', 'Grands comptes'],
  ['/sous-traitance/toitures-industrielles', 'Types de chantiers'],
  ['/prestations-photovoltaiques/chantier-complet', 'Chantier complet'],
  ['/references-photovoltaique', 'Références'],
  ['/reserver-equipe', 'Réserver une équipe'],
  ['/dossier-fournisseur', 'Dossier fournisseur'],
  ['/devis', 'Envoyer un projet'],
];

export default function SousNavPV() {
  return (
    <nav aria-label="Sous-traitance photovoltaïque" style={{ background: '#fff', borderBottom: '1px solid var(--ev-line)' }}>
      <div className="ev-wrap" style={{ display: 'flex', gap: 6, overflowX: 'auto', padding: '10px 0', scrollbarWidth: 'none' }}>
        <span style={{ fontWeight: 900, color: 'var(--ev-navy)', fontSize: 13, whiteSpace: 'nowrap', alignSelf: 'center', marginRight: 6 }}>☀️ Sous-traitance PV :</span>
        {LIENS.map(([to, l]) => (
          <NavLink key={to} to={to} style={({ isActive }) => ({ whiteSpace: 'nowrap', padding: '7px 12px', borderRadius: 20, fontSize: 13, fontWeight: 800, textDecoration: 'none',
            background: isActive ? 'var(--ev-navy)' : '#F3F4F6', color: isActive ? '#fff' : 'var(--ev-navy)' })}>{l}</NavLink>
        ))}
      </div>
    </nav>
  );
}
